import * as React from "react";
import ButtonComponent from "components/Button";
import { Box, Typography, Divider } from "@mui/material";
import { H5, H6 } from "components/CustomTypography";

const SellerDeliveryServicePreview = ({
  isLoading, service, editService, cancelEdit,
}) => {
  const { shippingoption, orderminimum, shipping, delivery_accountid } = service;

  // Group delivery options by type
  const shopDeliveryOptions = ["freeshipping", "shippingcost", "actualcost"];
  const shopanaDeliveryOptions = ["thirdparty", "thirdpartyfree", "thirdpartyminimum"];

  const isShopDelivery = shopDeliveryOptions.includes(shippingoption);
  const isShopanaDelivery = shopanaDeliveryOptions.includes(shippingoption);
  
  // Check if Shopana delivery is enabled for this shop
  const isShopanaDeliveryEnabled = !!delivery_accountid;

  const renderShopDelivery = () => {
    switch(shippingoption) {
      case "freeshipping":
        return (
          <Typography sx={{ ml: 2 }}>
            • Free with all orders
          </Typography>
        );
      case "shippingcost":
        return (
          <Box sx={{ ml: 2 }}>
            <Typography>• Free with minimum order: ₹{orderminimum || 0}</Typography>
            <Typography sx={{ mt: 0.5 }}>• Delivery cost: ₹{shipping || 0}</Typography>
          </Box>
        );
      case "actualcost":
        return (
          <Typography sx={{ ml: 2 }}>
            • Actual Charges (calculated at checkout)
          </Typography>
        );
      default:
        return null;
    }
  };

  const renderShopanaDelivery = () => {
    switch(shippingoption) {
      case "thirdparty":
        return (
          <Typography sx={{ ml: 2 }}>
            • Standard delivery charges apply
          </Typography>
        );
      case "thirdpartyfree":
        return (
          <Typography sx={{ ml: 2 }}>
            • FREE delivery on all orders
          </Typography>
        );
      case "thirdpartyminimum":
        return (
          <Typography sx={{ ml: 2 }}>
            • Free delivery on orders above: ₹{orderminimum || 0}
          </Typography>
        );
      default:
        return null;
    }
  };

  return (
    <Box display="flex">
      <Box overflow="hidden" width="80%" className="p-3">
        {shippingoption === "noshipping" ? (
          <Typography color="text.secondary">
            No Delivery (Disabled)
          </Typography>
        ) : (
          <Box>
            {/* Delivery by Shop Section */}
            <Box sx={{ mb: 2 }}>
              <H5 sx={{ mb: 1, color: isShopDelivery ? "primary.main" : "text.secondary" }}>
                Delivery by Shop
              </H5>
              {isShopDelivery ? (
                renderShopDelivery()
              ) : (
                <Typography sx={{ ml: 2, color: "text.secondary", fontSize: "0.875rem" }}>
                  Not configured
                </Typography>
              )}
            </Box>

            <Divider sx={{ my: 2 }} />

            {/* Delivery via Shopana Delivery Partner Section */}
            <Box>
              <H5 sx={{ mb: 1, color: isShopanaDelivery ? "primary.main" : "text.secondary" }}>
                Delivery via Shopana Delivery Partner
                {isShopanaDeliveryEnabled && (
                  <Typography component="span" sx={{ ml: 1, fontSize: "0.75rem", color: "success.main", fontWeight: 400 }}>
                    (Enabled)
                  </Typography>
                )}
                {!isShopanaDeliveryEnabled && (
                  <Typography component="span" sx={{ ml: 1, fontSize: "0.75rem", color: "warning.main", fontWeight: 400 }}>
                    (Not Available)
                  </Typography>
                )}
              </H5>
              {isShopanaDeliveryEnabled ? (
                <>
                  {isShopanaDelivery ? (
                    renderShopanaDelivery()
                  ) : (
                    <Typography sx={{ ml: 2, color: "text.secondary", fontSize: "0.875rem" }}>
                      Not configured
                    </Typography>
                  )}
                </>
              ) : (
                <Box sx={{ ml: 2 }}>
                  <Typography sx={{ color: "text.secondary", fontSize: "0.875rem" }}>
                    Contact support to enable Shopana Delivery Partner service.
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Box>
      <Box>
        {!isLoading && (
          <ButtonComponent
            sx={{
              m: 2,
            }}
            variant="contained"
            type="primary"
            name="Edit"
            size="small"
            onClick={editService}
          />
        )}
      </Box>
    </Box>
  );
};

export default SellerDeliveryServicePreview;
